<template>
  <ul
    :aria-label="i18n(translations.promptSuggestionsTitle)"
    class="flex flex-wrap gap-8"
  >
    <li v-for="(suggestion, index) in suggestions" :key="index">
      <RevChip
        :label="suggestion"
        size="small"
        @click="$emit('click', suggestion)"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevChip } from '@ds/components/Chip'

import translations from '../ShoppingAssistant.translations'

defineProps<{ suggestions: string[] }>()

defineEmits<{ click: [suggestion: string] }>()

const i18n = useI18n()
</script>
